import useComponentClickOutside from "utils/hooks/use-component-click-outside";

const DropdownSecondary = ({
  label,
  options,
  onSelect,
  disabled,
  className,
  identifier,
  compact,
}) => {
  const { wrapRef, toggleChild, isComponentVisible } =
    useComponentClickOutside();

  const handleDropdownClick = (e) => {
    e.preventDefault();
    toggleChild();
  };

  const buttonClass = compact
    ? "py-2 px-3 text-[13px] input-field-classes w-full text-start"
    : "py-3 px-[18px] text-base input-field-classes w-full text-start";

  const dropdownTopClass = compact ? "top-[38px]" : "top-[60px]";

  const optionClass = compact
    ? "px-3 py-1.5 hover:bg-shade-50 transition-all duration-100 ease-in-out text-[13px] text-muted"
    : "px-[18px] py-3 hover:bg-shade-50 transition-all duration-100 ease-in-out text-xl text-muted";

  return (
    <div className={`relative ${className}`} ref={wrapRef}>
      <button
        disabled={disabled}
        onClick={handleDropdownClick}
        className={buttonClass}
      >
        <span className="overflow-hidden overflow-ellipsis whitespace-nowrap block">
          {label}
        </span>
      </button>

      {isComponentVisible && (
        <div className={`absolute w-full md:w-max bg-white left-0 ${dropdownTopClass} shadow-pop z-10`}>
          {options.map((option, idx) => {
            return (
              <p
                onClick={() => {
                  onSelect(option);
                  toggleChild();
                }}
                key={options[identifier] || `${identifier}-${idx}`}
                className={optionClass}
              >
                {option.label}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DropdownSecondary;